import { localizedText } from "../helpers/localization"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["views", "likes", "comments", "shares", "status", "result", "rate", "rating"]

  calculate(event) {
    event.preventDefault()

    const views = this.#positiveNumber(this.viewsTarget.value, localizedText(this.element, "views"))
    const likes = this.#requiredNumber(this.likesTarget.value, localizedText(this.element, "likes"))
    const comments = this.#requiredNumber(this.commentsTarget.value, localizedText(this.element, "comments"))
    const shares = this.#optionalNumber(this.sharesTarget.value)
    if (views === null || likes === null || comments === null || shares === null) return

    const rate = ((likes + comments + shares) / views) * 100
    this.rateTarget.textContent = new Intl.NumberFormat(this.element.ownerDocument.body.lang, { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rate / 100)
    this.ratingTarget.textContent = this.#ratingFor(rate)
    this.statusTarget.textContent = ""
    this.resultTarget.classList.remove("hidden")
  }

  recalculate() {
    this.resultTarget.classList.add("hidden")
    this.statusTarget.textContent = ""
    this.viewsTarget.focus()
  }

  #requiredNumber(value, label) {
    if (value.trim() === "") {
      this.#showError(localizedText(this.element, "required", { label }))
      return null
    }

    return this.#nonNegativeNumber(value, label)
  }

  #positiveNumber(value, label) {
    if (value.trim() === "") {
      this.#showError(localizedText(this.element, "required", { label }))
      return null
    }

    const number = Number(value)
    if (!Number.isFinite(number) || number <= 0) {
      this.#showError(localizedText(this.element, "positive_number", { label }))
      return null
    }
    return number
  }

  #optionalNumber(value) {
    return value.trim() === "" ? 0 : this.#nonNegativeNumber(value, localizedText(this.element, "shares"))
  }

  #nonNegativeNumber(value, label) {
    const number = Number(value)
    if (!Number.isFinite(number) || number < 0) {
      this.#showError(localizedText(this.element, "nonnegative_number", { label }))
      return null
    }
    return number
  }

  #ratingFor(rate) {
    if (rate < 1) return localizedText(this.element, "poor")
    if (rate < 3) return localizedText(this.element, "below_average")
    if (rate < 5) return localizedText(this.element, "average")
    if (rate < 10) return localizedText(this.element, "good")

    return localizedText(this.element, "excellent")
  }

  #showError(message) {
    this.statusTarget.textContent = message
    this.statusTarget.classList.add("text-red-300")
    this.resultTarget.classList.add("hidden")
  }
}
